import * as yup from "yup";
export const GrnlineItemSchema = yup.object().shape({
  particulars: yup.string(),
  itemUnit: yup.string(),
  totalWithoutGst: yup.number().nullable(),
  totalWithGst: yup.number().nullable(),
  itemQuantity: yup.string(),
  discount: yup.string(),
  itemPrice: yup.string(),
  gstRate: yup.string(),
  deliveryDate: yup.string(),
  notes: yup.string(),
  id: yup.string(),
  hsn: yup.string(),
  sku: yup.string(),
  itemFrom: yup.string(),
  recivedQty: yup.string(),
});

export const GrnPurchaseOrderSchema = yup.object().shape({
  project: yup.string(),
  vendor: yup.string().required("Required"),
  poType: yup.string(),
  poId: yup.string().required("Required"),
  /////////// new Added
  vendorInvoiceNumber: yup.string(),
  paymentPriority: yup.string(),
  taxInvoice: yup.mixed(),
  performaInvoice: yup.mixed(),
  approveStatus: yup.boolean(),
  paymentAmount: yup.string(),
  paymentType: yup.string(),
  notes: yup.string(),
  //////////////
  pdfStatus: yup.boolean(),
  countryOfSupply: yup.string(),
  placeOfSupply: yup.string(),
  generatedBy: yup.string(),
  vendorPurchaseOrderDate: yup.date(),
  vendorPurchaseOrderFor: yup.string(),
  lineItems: yup.array().of(GrnlineItemSchema),
});
